import Typography from '@anwb/poncho/components/typography';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import styled, { DefaultThemeProps, css } from 'styled-components';

const PaymentInAdvanceTextStyles = ({
	theme,
	isGreen,
}: DefaultThemeProps & { isGreen?: boolean }) => css`
	${isGreen &&
	css`
		color: ${theme.colors.positive.textPrice};
	`}
	font-weight: normal;
`;

export const PaymentInAdvanceText = styled(Typography)`
	${PaymentInAdvanceTextStyles}
`;

const PaymentInAdvanceContainerStyles = ({ theme }: DefaultThemeProps) => css`
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		width: 50%;
	}
`;

export const PaymentInAdvanceContainer = styled.div`
	${PaymentInAdvanceContainerStyles}
`;
